import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";

import { CustomTabs } from "../../../components";
import BreadCrumbsMUI from "../../../components/molecules/breadcrumpMUI/breadcrumpMUI";
import { TMuiOptionTabType } from "../../../components/molecules/custom-tab/custom-tab";
import { useUser } from "../../../context";
import { useFetch } from "../../../hooks";
import { TProject } from "../../../models";
import { projects } from "../../../services";
import * as s from "./styled-project";
import { TabActivities } from "./tab-activities/tab-activities";
import AnnotationTab from "./tab-annotation/annotation-tab";
import { TabCollabs } from "./tab-collabs/tab-collabs";
import { DashboardTab } from "./tab-dashboard/dashaboard-tab";
import { TabDescription } from "./tab-description/tab-description";
import FilesTab from "./tab-files/files-tab";
import TabGantt from "./tab-gantt/tab-gantt";

const rotes = [
    {
        label: "Projetos",
        href: "/projetos",
    },
];

export const mockBars = [
    {
        id: "1",
        name: "Project Planning",
        startIndex: 0,
        endIndex: 1,
        row: 0,
        color: "#4CAF50",
    },
    {
        id: "2",
        name: "Development Phase",
        startIndex: 1,
        endIndex: 3,
        row: 1,
        color: "#2196F3",
    },
    {
        id: "3",
        name: "Testing",
        startIndex: 3,
        endIndex: 4,
        row: 2,
        color: "#FF9800",
    },
    {
        id: "4",
        name: "Documentation",
        startIndex: 2,
        endIndex: 5,
        row: 3,
        color: "#9C27B0",
    },
    {
        id: "5",
        name: "Deployment",
        startIndex: 5,
        endIndex: 6,
        row: 4,
        color: "#F44336",
        warning: "Critical path",
    },
    {
        id: "6",
        name: "Review & Feedback",
        startIndex: 4,
        endIndex: 6,
        row: 5,
        color: "#607D8B",
    },
];

export const mockTimelineDates = [
    "01/01/24",
    "15/01/24",
    "01/02/24",
    "15/02/24",
    "01/03/24",
    "15/03/24",
    "01/04/24",
];

export const Project = () => {
    const { verifyPermission } = useUser();

    const viewProjectsPermission = verifyPermission({
        id: "projects_sectors",
        rule: "view",
    });

    const location = useLocation();
    const [project, setProject] = useState<TProject>(location?.state?.project);
    const [loading, setLoading] = useState<boolean>(true);

    const getProject = useFetch({
        fn: projects.getProject,
        start: false,
    });

    useEffect(() => {
        if (location?.state?.project?.id_e) {
            getProject.onRefresh({
                projectId: location?.state?.project?.id_e,
                users: true,
                hours: true,
                finished: false,
                sectors: true,
                reviewers: true,
                all: true,
            });
        }
    }, [location?.state?.project?.id_e]);

    const currentRouteName = location?.state?.project?.name ?? "";

    const options: TMuiOptionTabType = [
        {
            title: "DASHBOARD",
            content: <DashboardTab project={project} />,
        },
        {
            title: "ATIVIDADES",
            content: <TabActivities loading={loading} project={project} />,
        },

        {
            title: "GANTT",

            content: <TabGantt project={project} />,
        },
        {
            title: "TIME",
            content: <TabCollabs project={project} getProject={getProject} />,
        },
        {
            title: "DESCRIÇÃO",
            content: (
                <TabDescription
                    project={project}
                    getProject={getProject}
                    loading={loading}
                    setLoading={setLoading}
                />
            ),
        },
        {
            title: "ANEXOS",
            content: <FilesTab project={project} getProject={getProject} />,
        },
        {
            title: "ANOTAÇÕES",
            content: (
                <AnnotationTab project={project} getProject={getProject} />
            ),
        },
    ];

    const tabOptions = !viewProjectsPermission
        ? options.filter(
              (option) =>
                  option.title !== "DESCRIÇÃO" && option.title !== "TIME"
          )
        : options;
    useEffect(() => {
        if (getProject.error) {
            toast.error(`${getProject.error}`);
            setLoading(getProject.loading);
        }
        if (getProject.response) {
            setProject(getProject.response.projects[0]);
            setLoading(getProject.loading);
        }
    }, [getProject.response, getProject.error, getProject.loading]);
    return (
        <>
            <s.Header>
                <BreadCrumbsMUI
                    breadcrumpRotes={rotes}
                    currentRote={currentRouteName}
                />
            </s.Header>

            <s.Container>
                <CustomTabs tabOptions={tabOptions} />
            </s.Container>
        </>
    );
};
